import React from 'react';
import DetailIcon from '@/common/detail-icon';
import '../styles/star-rating.less';
interface StarRatingProps {
  rating: number;
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1;
  const starElements = [];

  for (let i = 0; i < fullStars; i++) {
    starElements.push(
      <DetailIcon key={i} className={'detail-symbol fa-star'} symbol={'icon-rating-star-fill'} />,
    );
  }

  if (hasHalfStar > 0) {
    starElements.push(
      <div className={'fa-star-half'}>
        <div
          className={'fa-star-half-layout'}
          style={{
            width: `${hasHalfStar * 100}%`,
          }}
        >
          <DetailIcon key="half" className={'detail-symbol'} symbol={'icon-rating-star-fill'} />
        </div>
        <DetailIcon key="half" className={'detail-symbol'} symbol={'icon-rating-star-fill'} />
      </div>,
    );
  }

  const remainingStars = 5 - Math.ceil(rating); // Remaining empty stars
  for (let i = 0; i < remainingStars; i++) {
    starElements.push(
      <DetailIcon
        key={i + 10}
        className={'detail-symbol fa-none-star'}
        symbol={'icon-rating-star-fill'}
      />,
    );
  }

  return <div className={'star-rating-list'}>{starElements}</div>;
};

export default StarRating;
